<style>
</style>
<template>
    <div>
        <div class="well">
            <button class="btn btn-default" v-on:click.prevent="openEmptyModal">
                新增國定假日
            </button>
        </div>
        <table class="table">
            <thead>
                <tr>
                    <th>
                        日期
                    </th>
                    <th>
                        名稱
                    </th>
                    <th>
                        假日
                    </th>
                    <th>
                        動作
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items" :key="item.uuid">
                    <td>{{item.date}}</td>
                    <td>{{item.title}}</td>
                    <td>{{item.should_work?'':'V'}}</td>
                    <td>
                        <button class="btn btn-success" v-on:click.prevent="openModal(item.uuid)">修改</button>

                        <button class="btn btn-danger" v-on:click.prevent="deleteItem(item.uuid)">刪除</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{editItem.uuid ? '修改': '新增'}}國定假日</h4>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="form-group">
                                <label>日期</label>
                                <input type="text" class="form-control" placeholder="2016-09-01" v-model="editItem.date">
                            </div>
                            <div class="form-group">
                                <label>名稱</label>
                                <input type="text" class="form-control" placeholder="簡訊假日" v-model="editItem.title">
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" v-model="editItem.is_holiday">
                                    是假日
                                </label>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">關閉</button>
                        <button type="button" class="btn btn-primary" v-on:click.prevent="updateItem(editItem.uuid, editItem)">儲存</button>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        computed: {
        },

        data() {
            return {
                items: [],
                loading: false,
                modalOpen: false,
                editItem: {},
            }
        },

        methods: {
            openEmptyModal: function() {
                var dateString, date = new Date();
                dateString = moment().format('YYYY-MM-DD');
                this.editItem = {
                    uuid: '',
                    date: dateString,
                    title: '',
                    is_holiday: true,
                };
                this.modalOpen = true
            },

            openModal: function(uuid) {
                for (let itemId in this.items) {
                    var item = this.items[itemId];
                    if (item.uuid === uuid) {
                        this.editItem = {
                            uuid: item.uuid,
                            date: item.date,
                            title: item.title,
                            is_holiday: !item.should_work,
                        };
                    }
                }
                this.modalOpen = true
            },
            updateItem: function(uuid, data) {
                var formData = {
                    date: data.date,
                    title: data.title,
                    should_work: !data.is_holiday,
                };

                var target;

                var onSuccess = ((response) => {
                        this.requestResting();
                        swal('修改成功');
                        this.modalOpen = false;
                        this.loading = false;
                }).bind(this);

                var onFail = (response) => {
                        var errors = response.response.data;
                        var errorString = '';
                        for (errorId in errors) {
                            errorString = errors[errorId];
                        }
                        swal('修改失敗：' + errorString);
                        this.loading = false;
                };

                if (uuid) {
                  target = "/api/date/" + uuid;
                  axios.put(target, formData)
                    .then(onSuccess)
                    .catch(onFail)
                } else {
                  target = "/api/date";
                  axios.post(target, formData)
                    .then(onSuccess)
                    .catch(onFail)
                }

            },
            deleteItem: function(uuid) {
                swal({
                    title: "確定刪除?",
                    text: "再確定一下喔!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "刪!",
                    closeOnConfirm: true,
                }, (function(){
                    this.loading = true;
                    this.$http.post('/api/date/' + uuid, {_method: 'delete'})
                            .then((function(response) {
//                                swal('成功刪除');
                                this.requestResting();
                                this.loading = false;
                            }).bind(this), function(response) {
                                swal('無法刪除');
                                console.error('fail to get resting data', response);
                                this.loading = false;
                            });
                }).bind(this));
            },

            requestResting: function() {
                this.$http.get('/api/date')
                        .then((function(response) {
                           var datas = response.data;

                           if ('string' === typeof(datas)) {
                             datas = JSON.parse(response.data);
                           }

                            this.items = datas;
                        }).bind(this), (function(response) {
                            this.error = response.data;
                        }).bind(this))
            },
        },

        mounted() {
            this.requestResting();

            $(this.$el.querySelectorAll('.modal')).on('hide.bs.modal', (function() {
                this.modalOpen = false;
            }).bind(this));

            this.$watch('modalOpen', function(value) {
                var $modal = $(this.$el.querySelectorAll('.modal'));
                if(value) {
                    $modal.modal('show');
                } else {
                    $modal.modal('hide');
                }
            });
        }
    }
</script>
